import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/img/logo.png";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdCall } from "react-icons/md";
import { RiInstagramFill } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaEnvelope } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";

export default function Footer() {
  const quickLinks = [
    {
      url: "/",
      title: "Home",
    },
    {
      url: "/about",
      title: "About Yanaa",
    },
    {
      url: "/services",
      title: "Services",
    },
    {
      url: "https://wa.me/917022851682/",
      title: "Contact",
    },
  ];
  return (
    <div className="footer" style={{ background: "#e1cfc12b" }}>
      <div className="container pt-5 pb-4">
        <div className="row justify-content-between">
          <div className="col-md-5">
            <img src={Logo} alt="LOGO" width={"150px"} />
            <p className="pt-3">
              YANAA HOMES is a full-service interior design firm that designs
              spaces from concept to completion in Bengaluru. We create custom
              interiors for new builds and renovation projects.
            </p>
            <p className="pt-2 mob-hide">
              Copyright © {new Date().getFullYear()} Yanaa Homes. All Rights
              Reserved.
            </p>
          </div>
          <div className="col-md-5">
            <div className="row">
              <div className="col-md-6 quicklinks">
                <h6>Quick Links</h6>
                <ul className="list-unstyled">
                  {quickLinks.map((item) => {
                    return (
                      <li key={item.url}>
                        <Link to={item.url}>
                          <MdKeyboardArrowRight /> {item.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="col-md-6">
                <h6>Reach Us</h6>
                <ul className="list-unstyled reach">
                  <li>
                    <Link to="/">
                      <FaMapMarkerAlt />{" "}
                      <span>
                        YANAA HOMES Tulasi house, Nandini Layout, Bengaluru,
                        Karnataka 560096
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="tel:7022851682">
                      <MdCall /> <span>+91 7022851682</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="mailto:yashwanth@yanaahomes.com">
                      <FaEnvelope /> <span>yashwanth@yanaahomes.com</span>
                    </Link>
                  </li>
                </ul>
                <p className="icons pt-1">
                  <h6>Follow Us</h6>
                  <Link
                    to="https://www.instagram.com/yanaa_homes/"
                    target="_blank"
                  >
                    <RiInstagramFill />
                  </Link>
                  <Link to="https://pin.it/JCTKwunZ4" target="_blank">
                    <FaPinterest />
                  </Link>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
